import angular from 'angular';

import component from './dealerChatLink.component';
import NgTracking from 'cars-ng-tracking';
import NgBrowser from 'cars-ng-browser';
import DealerChatService from '../index';
import ActiveEngage from '../../activeEngage';
import LeadForm from '../../leadForm';

export default angular.module('vdp.dealerChat.dealerChatLink', [
    NgTracking,
    NgBrowser,
    DealerChatService,
    ActiveEngage,
    LeadForm
])

.component('carsDealerChatLink', component)

.name;
